// extracted by mini-css-extract-plugin
export default {"simpleButton":"Button_simpleButton__6ihc7","button":"Button_button__cd9Mk","oscTypeSelected":"Button_oscTypeSelected__QbWx6"};